import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/justservicelogo.png';
import api from '../../utils/api';
import { subCategories } from '../../utils/categoryData';
import './Home.css';

function ComingSoonPopup({ onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 2500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className="cs-overlay" onClick={onClose}>
      <div className="cs-popup" onClick={e => e.stopPropagation()}>
        <div className="cs-icon">🚀</div>
        <h3>Coming Soon!</h3>
        <p>Our app is launching soon on<br />Google Play &amp; App Store.</p>
        <div className="cs-bar"><div className="cs-bar-fill" /></div>
      </div>
    </div>
  );
}

const bannerSlides = [
  {
    bg: 'linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%)',
    title: 'Promote Your', bold: 'Business',
    sub: 'in Your District with AdSet',
    desc: 'Advertise in the right place, reach the right people.',
    btn: 'Start Now', path: '/adset',
  },
  {
    bg: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
    title: 'List Your', bold: 'Business FREE',
    sub: 'Get Discovered Locally',
    desc: 'India\'s FREE Business Listing Platform for B2B & B2C.',
    btn: 'Add Business', path: '/add-business',
  },
  {
    bg: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    title: 'Create Your', bold: 'Digital Poster',
    sub: 'Instant Design & Share',
    desc: 'Create stunning posters for festivals, greetings & more.',
    btn: 'Create Now', path: '/digital-poster',
  },
];

const searchTexts = ['Service Provider', 'Traders', 'Business', 'Company', 'Startup', 'Manufacturer'];

const highlights = [
  { title: 'Press & Media', subtitle: 'Top News', bg: 'linear-gradient(90deg,#009688,#00796b)', emoji: '📰' },
  { title: 'Celebrity', subtitle: 'Top Stars', bg: 'linear-gradient(90deg,#f48fb1,#e57373)', emoji: '⭐' },
  { title: 'Influencer', subtitle: 'Top Creators', bg: 'linear-gradient(90deg,#90caf9,#64b5f6)', emoji: '🎬' },
  { title: 'Emergency Number', subtitle: 'Quick Call', bg: 'linear-gradient(90deg,#ef5350,#e53935)', emoji: '🚨' },
];

const rentHire = [
  { name: 'Ac On Rent', emoji: '❄️', subcat: 'AC On Rent' },
  { name: 'Bus', emoji: '🚌', subcat: 'Bus On Rent' },
  { name: 'Car', emoji: '🚗', subcat: 'Car On Rent' },
  { name: 'Costumes', emoji: '👗', subcat: null },
  { name: 'Furniture', emoji: '🪑', subcat: 'Furniture On Rent' },
  { name: 'Horses On Rent', emoji: '🐴', subcat: null },
  { name: 'House & Room', emoji: '🏠', subcat: 'House On Rent' },
  { name: 'Mini Bus', emoji: '🚐', subcat: 'Bus On Rent' },
  { name: 'Scooter', emoji: '🛵', subcat: 'Bike On Rent' },
  { name: 'Tempo', emoji: '🚛', subcat: null },
];

const popularItems = [
  { name: 'Education', emoji: '🎓', category: 'Education' },
  { name: 'Jewellery', emoji: '💍', category: 'Jewellery & Gemstones' },
  { name: 'Grocery', emoji: '🛒', category: 'Grocery And General Store' },
  { name: 'Hotel', emoji: '🏨', category: 'Hotel' },
  { name: 'Mobile', emoji: '📱', category: 'Mobile' },
  { name: 'Automobile', emoji: '🚗', category: 'Automobile' },
  { name: 'Restaurant', emoji: '🍽️', category: 'Restaurant And Dhaba' },
  { name: 'Vegetables', emoji: '🥦', category: 'Vegetables And Fruits' },
  { name: 'Decorators', emoji: '🎨', category: 'Decorators' },
  { name: 'Computer & IT', emoji: '🖥️', category: 'Computer & It' },
];

const exploreCards = [
  { title: 'DOCTOR\nCONSULTANCY', emoji: '🩺', bg: '#7C3AED', category: 'Doctor' },
  { title: 'RENT &\nHIRE', emoji: '🏠', bg: '#16a34a', category: 'Rent & Hire' },
  { title: 'REAL\nESTATE', emoji: '🏗️', bg: '#ea580c', category: 'Real Estate' },
  { title: 'DIGITAL\nMARKETING', emoji: '📊', bg: '#2563eb', category: 'Digital Marketing' },
  { title: 'BUSINESS\nCONSULTANT', emoji: '💼', bg: '#7C3AED', category: 'Business Development' },
  { title: 'APP & WEB\nDEV', emoji: '💻', bg: '#ea580c', category: 'App And Web Development' },
];

const popularBrands = [
  { bg: 'linear-gradient(135deg,#e0f2fe,#bfdbfe)', text: 'Promote Your Business\nin Your District\nwith AdSet', sub: 'Advertise in the right place,\nreach the right people.', btn: 'Start Now' },
  { bg: 'linear-gradient(135deg,#fef9c3,#fde68a)', text: 'Take Your Business\nTo The Next Level', sub: 'List Your Business FREE', btn: 'Start Now' },
];

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showPosterPopup, setShowPosterPopup] = useState(false);
  const [showStorePop, setShowStorePop] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(0);
  const [searchIdx, setSearchIdx] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [locationText, setLocationText] = useState('');
  const [locLoading, setLocLoading] = useState(false);
  const [locError, setLocError] = useState(false);
  const [locationConsent, setLocationConsent] = useState(false);
  const [showLocationPrompt, setShowLocationPrompt] = useState(true);
  const [exploreIdx, setExploreIdx] = useState(0);
  const [brandIdx, setBrandIdx] = useState(0);
  const exploreRef = useRef();
  const [businessCats, setBusinessCats] = useState([]);
  const [professionalCats, setProfessionalCats] = useState([]);
  const [topBannerAd, setTopBannerAd] = useState(null);

  // Fetch categories from API
  useEffect(() => {
    // Set default categories if API fails
    const defaultBusinessCats = [
      { name: 'Restaurant', icon: '🍽️' },
      { name: 'Shopping', icon: '🛒' },
      { name: 'Healthcare', icon: '🏥' },
      { name: 'Education', icon: '🎓' },
      { name: 'Automobile', icon: '🚗' },
      { name: 'Real Estate', icon: '🏠' }
    ];
    
    const defaultProfessionalCats = [
      { name: 'Plumber', icon: '🔧' },
      { name: 'Electrician', icon: '⚡' },
      { name: 'Carpenter', icon: '🔨' },
      { name: 'Painter', icon: '🎨' },
      { name: 'Cleaner', icon: '🧹' },
      { name: 'Mechanic', icon: '⚙️' }
    ];

    api.get('/api/categories/all')
      .then(res => {
        const data = res.data.data;
        setBusinessCats(data.business.categories);
        setProfessionalCats(data.professional.categories);
      })
      .catch(() => {
        // Use default categories if API fails
        setBusinessCats(defaultBusinessCats);
        setProfessionalCats(defaultProfessionalCats);
      });
      
    // Fetch active top banner adset
    api.get('/api/adsets?bannerPosition=Top Banner')
      .then(res => {
        const ads = res.data.data || [];
        if (ads.length > 0) setTopBannerAd(ads[0]);
      })
      .catch(() => {
        // Ignore banner ad errors
      });
  }, []);

  // GPS location with user consent
  const requestLocation = () => {
    if (!navigator.geolocation) { setLocError(true); return; }
    setLocLoading(true);
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
          const data = await res.json();
          const a = data.address;
          const city = a.city || a.town || a.village || a.county || '';
          const state = a.state || '';
          setLocationText(city && state ? `${city}, ${state}` : city || state || 'Location found');
        } catch { setLocationText('Location found'); }
        setLocLoading(false);
        setLocationConsent(true);
        setShowLocationPrompt(false);
      },
      () => { setLocError(true); setLocLoading(false); }
    );
  };

  useEffect(() => {
    // Don't auto-request location anymore
  }, []);

  useEffect(() => {
    const t1 = setInterval(() => setSearchIdx(p => (p + 1) % searchTexts.length), 2000);
    const t2 = setInterval(() => setBrandIdx(p => (p + 1) % popularBrands.length), 4000);
    const t3 = setInterval(() => setCurrentBanner(p => (p + 1) % bannerSlides.length), 3500);
    return () => { clearInterval(t1); clearInterval(t2); clearInterval(t3); };
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchText.trim()) navigate(`/search?q=${encodeURIComponent(searchText.trim())}`);
  };

  const handleServiceClick = (s) => {
    if (s.path === 'digital-poster-popup') { setShowPosterPopup(true); return; }
    if (s.path === 'hr-popup') { window.open('https://justhiring24.com/', '_blank'); return; }
    if (s.path) navigate(s.path);
    else alert('Coming Soon!');
  };

  const scrollExplore = (dir) => {
    if (exploreRef.current) exploreRef.current.scrollBy({ left: dir * 180, behavior: 'smooth' });
  };

  return (
    <div className="home">
      <div className="home-content container">

        {/* ── 1. Hero Banner + YouTube Video ── */}
        <div className="hero-row">
          {topBannerAd ? (
            <div className="hero-banner" style={{ background: '#000', padding: 0, overflow: 'hidden', cursor: 'pointer' }}
              onClick={() => navigate('/adset')}>
              <img
                src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/${topBannerAd.image}`}
                alt={topBannerAd.businessName}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          ) : (
            <div className="hero-banner" style={{ background: bannerSlides[currentBanner].bg }}>
              <div className="hero-text">
                <h1>{bannerSlides[currentBanner].title}<br /><span>{bannerSlides[currentBanner].bold}</span></h1>
                <p>{bannerSlides[currentBanner].sub}</p>
                <small>{bannerSlides[currentBanner].desc}</small>
                <button className="hero-btn" onClick={() => navigate(bannerSlides[currentBanner].path)}>
                  {bannerSlides[currentBanner].btn}
                </button>
              </div>
              <div className="hero-phone">
                <div className="phone-mockup">
                  <div className="phone-screen">
                    <div className="phone-search-bar">
                      <span>🔍</span><span>Search Business here</span>
                    </div>
                    <div className="phone-cats">
                      {['🍽️ Restaurants','🏪 Shops','⚙️ Services','🏥 Health','🎓 Education','🔧 Plumber'].map((c,i)=>(
                        <div key={i} className="phone-cat-item">{c}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="hero-dots">
                {bannerSlides.map((_, i) => (
                  <span key={i} className={`hero-dot ${i === currentBanner ? 'active' : ''}`}
                    onClick={() => setCurrentBanner(i)} />
                ))}
              </div>
            </div>
          )}

          <div className="promo-panel">
            <p className="promo-panel-title">JustService24 Promotional Video</p>
            <div className="promo-video-wrap">
              <iframe
                src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=1&loop=1&playlist=dQw4w9WgXcQ&controls=1&rel=0"
                title="JustService24 Promotional Video"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                className="promo-yt-iframe"
              />
            </div>
          </div>
        </div>

        {/* ── 2. Search Bar ── */}
        <div className="search-section">
          {showLocationPrompt && (
            <div style={{ 
              background: '#e3f2fd', 
              padding: '12px', 
              borderRadius: '8px', 
              marginBottom: '16px', 
              textAlign: 'center' 
            }}>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>📍 Allow location access for better local results?</p>
              <button 
                onClick={requestLocation}
                style={{ 
                  background: '#2196f3', 
                  color: 'white', 
                  border: 'none', 
                  padding: '8px 16px', 
                  borderRadius: '4px', 
                  marginRight: '8px', 
                  cursor: 'pointer' 
                }}
              >
                Allow Location
              </button>
              <button 
                onClick={() => setShowLocationPrompt(false)}
                style={{ 
                  background: 'transparent', 
                  color: '#666', 
                  border: '1px solid #ddd', 
                  padding: '8px 16px', 
                  borderRadius: '4px', 
                  cursor: 'pointer' 
                }}
              >
                Skip
              </button>
            </div>
          )}
          <form onSubmit={handleSearch}>
            <div className="search-row">
              {locError ? (
                <button type="button" className="loc-error-btn" onClick={() => { setLocError(false); setLocLoading(true); }}>
                  ⚠️ Unable to get location
                </button>
              ) : (
                <div className="location-input-wrap">
                  <span className="loc-icon">📍</span>
                  <input
                    type="text"
                    placeholder={locLoading ? 'Fetching location...' : 'Enter Location'}
                    value={locationText}
                    onChange={e => setLocationText(e.target.value)}
                  />
                  {locLoading && <span className="loc-spinner" />}
                </div>
              )}
              <div className="search-input-wrap">
                <input
                  type="text"
                  placeholder={`Search ${searchTexts[searchIdx]} here`}
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
                <button className="search-btn" type="submit">🔍</button>
              </div>
            </div>
          </form>
        </div>

        {/* ── 3. Business Category ── */}
        <h2 className="section-title">Business Category <span style={{fontSize:'14px',color:'#666',fontWeight:'normal'}}>({businessCats.length})</span></h2>
        <div className="business-grid">
          {businessCats.map((cat, i) => (
            <div key={i} className="box-item" onClick={() => navigate(`/category/${encodeURIComponent(cat.name)}`)}>
              <div className="box-icon">{cat.icon}</div>
              <p className="box-label">{cat.name}</p>
            </div>
          ))}
        </div>
        <div className="view-more-wrap">
          <button className="view-more-btn" onClick={() => navigate('/categories/business')}>View More →</button>
        </div>

        {/* ── 4. Professional Service at Home ── */}
        <h2 className="section-title">Professional Service at Home <span style={{fontSize:'14px',color:'#666',fontWeight:'normal'}}>({professionalCats.length})</span></h2>
        <div className="business-grid">
          {professionalCats.map((cat, i) => (
            <div key={i} className="box-item" onClick={() => navigate(`/category/${encodeURIComponent(cat.name)}`)}>
              <div className="box-icon">{cat.icon}</div>
              <p className="box-label">{cat.name}</p>
            </div>
          ))}
        </div>
        <div className="view-more-wrap">
          <button className="view-more-btn" onClick={() => navigate('/categories/professional')}>View More →</button>
        </div>

        {/* ── 5. Highlights ── */}
        <h2 className="section-title left">Highlights</h2>
        <div className="highlights-grid">
          {highlights.map((h, i) => (
            <div key={i} className="highlight-box" style={{ background: h.bg }}
              onClick={() => navigate(`/category/${encodeURIComponent(h.title)}`)}>
              <div>
                <p className="hl-title">{h.title}</p>
                <span className="hl-badge">{h.subtitle}</span>
              </div>
              <span className="highlight-img">{h.emoji}</span>
            </div>
          ))}
        </div>

        {/* ── 6. Free Digital Services ── */}
        <h2 className="section-title">Free Digital Services</h2>
        <div className="services-grid">
          {[
            { bg: 'linear-gradient(135deg,#9C27B0,#673AB7)', icon: '🏢', label: 'Make Your Business Online', path: '/business-listing' },
            { bg: 'linear-gradient(135deg,#FF9800,#FF5722)', icon: '💼', label: 'Get & Post Job', path: 'hr-popup' },
            { bg: 'linear-gradient(135deg,#4CAF50,#8BC34A)', icon: '🎨', label: 'Free Digital Poster', path: 'digital-poster-popup' },
            { bg: 'linear-gradient(135deg,#2196F3,#03A9F4)', icon: '💳', label: 'Free Digital Visiting Card', path: '/visiting-card' },
          ].map((s, i) => (
            <div key={i} className="service-card" style={{ background: s.bg }}
              onClick={() => handleServiceClick(s)}>
              <div className="sc-icon-circle"><span>{s.icon}</span></div>
              <p className="sc-label">{s.label}</p>
            </div>
          ))}
        </div>

        {/* ── 7. Middle Ad + Rent & Hire + Popular ── */}
        <div className="mid-section">
          {/* Left: Ad Banner */}
          <div className="mid-ad-box">
            <h2 className="mid-ad-title">Advertise Here</h2>
            <div className="mid-ad-card">
              <div className="mid-ad-text">
                <h3>Promote Your<br /><strong>Business</strong></h3>
                <p>in Your District<br />with AdSet</p>
                <small>Advertise in the right place,<br />reach the right people.</small>
                <div className="mid-ad-btn">Start Now</div>
              </div>
              <div className="mid-ad-phone">
                <div className="mini-phone">
                  <div className="mini-phone-screen">
                    <span style={{fontSize:8}}>🔍 Search Business here</span>
                    <div style={{display:'flex',flexWrap:'wrap',gap:2,marginTop:4}}>
                      {['🍽️','🏪','⚙️','🏥','🎓','🔧'].map((e,i)=><span key={i} style={{fontSize:10}}>{e}</span>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Rent & Hire + Popular */}
          <div className="mid-right">
            <h2 className="section-title" style={{textAlign:'left',paddingTop:0}}>Rent & Hire</h2>
            <div className="popular-grid">
              {rentHire.map((item, i) => (
                <div key={i} className="popular-card" onClick={() => {
                  if (item.subcat) navigate(`/subcategory/${encodeURIComponent('Rent & Hire')}/${encodeURIComponent(item.subcat)}`);
                  else navigate(`/businesses?category=Rent & Hire&sub=${item.name}`);
                }}>
                  <span>{item.emoji}</span>
                  <p className="popular-text">{item.name}</p>
                </div>
              ))}
            </div>

            <h2 className="section-title" style={{textAlign:'left',paddingTop:'16px'}}>Popular</h2>
            <div className="popular-grid">
              {popularItems.map((item, i) => (
                <div key={i} className="popular-card" onClick={() => {
                  const cat = businessCats.find(c => c.name.toLowerCase().includes(item.name.toLowerCase())) || item;
                  if (cat?.subCategories?.length) navigate(`/category/${encodeURIComponent(cat.name)}`);
                  else navigate(`/businesses?category=${item.category || item.name}`);
                }}>
                  <span>{item.emoji}</span>
                  <p className="popular-text">{item.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── 8. Explore More ── */}
        <div className="explore-section">
          <h2 className="section-title">Explore More</h2>
          <div className="explore-slider-wrap">
            <button className="explore-arrow left" onClick={() => scrollExplore(-1)}>‹</button>
            <div className="explore-scroll" ref={exploreRef}>
              {exploreCards.map((card, i) => (
                <div key={i} className="explore-card" style={{ background: card.bg }}
                  onClick={() => {
                    if (subCategories[card.category]) navigate(`/category/${encodeURIComponent(card.category)}`);
                    else navigate(`/subcategory/${encodeURIComponent(card.category)}/${encodeURIComponent(card.category)}`);
                  }}>
                  <div className="explore-icon-circle"><span>{card.emoji}</span></div>
                  <h5>{card.title}</h5>
                </div>
              ))}
            </div>
            <button className="explore-arrow right" onClick={() => scrollExplore(1)}>›</button>
          </div>
        </div>

        {/* ── 9. Popular Brands ── */}
        <h2 className="section-title">Popular Brands</h2>
        <div className="brands-row">
          <div className="brands-slider-col">
            <button className="brand-arrow left" onClick={() => setBrandIdx(p => (p - 1 + popularBrands.length) % popularBrands.length)}>‹</button>
            <div className="brand-slide" style={{ background: popularBrands[brandIdx].bg }}>
              <div className="brand-slide-text">
                <h3>{popularBrands[brandIdx].text}</h3>
                <p>{popularBrands[brandIdx].sub}</p>
                <button className="brand-slide-btn" onClick={() => navigate('/adset')}>
                  {popularBrands[brandIdx].btn}
                </button>
              </div>
              <div className="brand-slide-phone">
                <div className="mini-phone">
                  <div className="mini-phone-screen">
                    <span style={{fontSize:7}}>🔍 Search Business here</span>
                    <div style={{display:'flex',flexWrap:'wrap',gap:2,marginTop:3}}>
                      {['🍽️','🏪','⚙️','🏥','🎓','🔧'].map((e,i)=><span key={i} style={{fontSize:9}}>{e}</span>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="brand-arrow right" onClick={() => setBrandIdx(p => (p + 1) % popularBrands.length)}>›</button>
          </div>
          <div className="brands-img-col">
            <div className="brands-img-placeholder">
              <div className="brands-img-content">
                <h3>TAKE YOUR BUSINESS<br />To The Next Level</h3>
                <p>List Your Business <strong>FREE</strong></p>
                <div className="brands-store-btns">
                  <a href="#" className="home-store-btn">
                    <svg viewBox="0 0 24 24" className="home-store-svg" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.18 23.76c.3.17.65.19.97.07l11.65-11.65L12 8.38 3.18 23.76z" fill="#EA4335"/>
                      <path d="M20.82 10.53l-2.6-1.5-3.24 3.24 3.24 3.24 2.62-1.51a1.49 1.49 0 0 0 0-2.6z" fill="#FBBC04"/>
                      <path d="M3.18.24A1.49 1.49 0 0 0 2.5 1.5v21a1.49 1.49 0 0 0 .68 1.26L15.82 12 3.18.24z" fill="#4285F4"/>
                      <path d="M3.18 23.76 15.82 12 12 8.18z" fill="#34A853"/>
                    </svg>
                    <div><small>GET IT ON</small><strong>Google Play</strong></div>
                  </a>
                  <a href="#" className="home-store-btn">
                    <svg viewBox="0 0 24 24" className="home-store-svg" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.37 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" fill="#fff"/>
                    </svg>
                    <div><small>Download on the</small><strong>App Store</strong></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── 10. App Download ── */}
        <div className="app-download-wrapper">
          <div className="app-phone-mockup">
            <img src={logo} alt="JustService24" className="app-phone-icon" />
            <p className="app-phone-name">JustService24</p>
            <div className="app-phone-bar" />
            <div className="app-phone-bar" />
            <div className="app-phone-bar" />
          </div>
          <div className="app-content">
            <span className="app-offer-badge">🎉 Exclusive App Offers</span>
            <h2>Download the JustService24 App!</h2>
            <p>Find local businesses, post jobs & get free digital services — all in one app.</p>
            <div className="app-store-btns">
              <a href="#" className="app-store-btn" onClick={e => { e.preventDefault(); setShowStorePop(true); }}>
                <svg viewBox="0 0 24 24" className="app-store-svg" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.18 23.76c.3.17.65.19.97.07l11.65-11.65L12 8.38 3.18 23.76z" fill="#EA4335"/>
                  <path d="M20.82 10.53l-2.6-1.5-3.24 3.24 3.24 3.24 2.62-1.51a1.49 1.49 0 0 0 0-2.6z" fill="#FBBC04"/>
                  <path d="M3.18.24A1.49 1.49 0 0 0 2.5 1.5v21a1.49 1.49 0 0 0 .68 1.26L15.82 12 3.18.24z" fill="#4285F4"/>
                  <path d="M3.18 23.76 15.82 12 12 8.18z" fill="#34A853"/>
                </svg>
                <div><span className="app-btn-small">GET IT ON</span><span className="app-btn-big">Google Play</span></div>
              </a>
              <a href="#" className="app-store-btn" onClick={e => { e.preventDefault(); setShowStorePop(true); }}>
                <svg viewBox="0 0 24 24" className="app-store-svg" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.37 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" fill="#fff"/>
                </svg>
                <div><span className="app-btn-small">Download on the</span><span className="app-btn-big">App Store</span></div>
              </a>
            </div>
          </div>
          <div className="app-qr-col">
            <p className="app-qr-label">📷 Scan to download</p>
            <div className="app-qr-box">
              <div className="qr-pattern">
                {Array(16).fill(0).map((_,i)=><div key={i} className={`qr-cell ${Math.random()>0.5?'filled':''}`}/>)}
              </div>
            </div>
            <p className="app-qr-sub">Android & iPhone</p>
          </div>
        </div>

        {/* ── 11. Local Video Buzz ── */}
        <div className="video-buzz-section">
          <h2 className="video-buzz-title"><span>Local</span> Video Buzz</h2>
          <p className="video-buzz-sub">Discover videos relevant to your area!</p>
          <div className="video-buzz-grid">
            {['dQw4w9WgXcQ','jNQXAC9IVRw','9bZkp7q19f0'].map((id, i) => (
              <div key={i} className="video-buzz-item">
                <iframe
                  src={`https://www.youtube.com/embed/${id}?controls=1&rel=0`}
                  title={`Local Video ${i+1}`}
                  frameBorder="0"
                  allow="encrypted-media"
                  allowFullScreen
                  className="video-buzz-iframe"
                />
              </div>
            ))}
          </div>
        </div>

      </div>

      {showStorePop && <ComingSoonPopup onClose={() => setShowStorePop(false)} />}
      {showPosterPopup && (
        <div className="modal-overlay" onClick={() => setShowPosterPopup(false)}>
          <div className="home-poster-popup" onClick={e => e.stopPropagation()}>
            <button className="home-poster-popup-close" onClick={() => setShowPosterPopup(false)}>✕</button>
            <h3>Complete Your Profile</h3>
            <p>Click <b>Edit Profile</b> to update your photo,<br />occupation, and address.<br />Once done, click <b>Make Design</b>.</p>
            <div className="home-poster-popup-btns">
              <button className="hpp-btn edit" onClick={() => { setShowPosterPopup(false); navigate('/create-profile'); }}>Edit Profile</button>
              <button className="hpp-btn make" onClick={() => { setShowPosterPopup(false); navigate('/digital-poster'); }}>Make Design</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
